import * as tslib_1 from "tslib";
import { AfterViewInit, ElementRef, EventEmitter, NgZone, OnChanges, QueryList, SimpleChanges } from '@angular/core';
import { AgmInfoWindow, AgmMap, AgmMarker } from '@agm/core';
import { AgmSnazzyInfoWindow } from '@agm/snazzy-info-window';
import { ControlPosition } from '@agm/core/services/google-maps-types';
import { GoogleService } from '../../google/google.service';
import { AirportSearchResult } from '../../airport/models/airport-search-result.model';
import { BoundingBox } from '../../util/geodesy/bounding-box';
import { LatLon } from '../../util/geodesy/latlon';
import { AviationEvent, AviationEventType } from '../../shared/models/aviation-event.model';
import { AviationEventFilter } from '../../shared/models/aviation-event-filter.model';
import * as moment from 'moment-timezone';
import { AnalyticsService } from '../../airport/service/google-analytics-4.service';
import { AuthService } from '../../auth/auth/auth.service';
var ResultsMapComponent = /** @class */ (function () {
    function ResultsMapComponent(_zone, el, _google, _analyticsService, _auth) {
        this._zone = _zone;
        this.el = el;
        this._google = _google;
        this._analyticsService = _analyticsService;
        this._auth = _auth;
        this.onEventsTab = false;
        this.airportClick = new EventEmitter();
        this.airportMouseEnter = new EventEmitter();
        this.airportMouseLeave = new EventEmitter();
        this.airportCardClose = new EventEmitter();
        this.activityClick = new EventEmitter();
        this.activityMouseEnter = new EventEmitter();
        this.activityMouseLeave = new EventEmitter();
        this.activityCardClose = new EventEmitter();
        this.boundsChange = new EventEmitter();
        this.aviationEventClick = new EventEmitter();
        this.aviationEventMouseEnter = new EventEmitter();
        this.aviationEventMouseLeave = new EventEmitter();
        this.aviationEventCardClose = new EventEmitter();
        this.mapTypeControlOptions = {
            position: ControlPosition.TOP_RIGHT
        };
    }
    Object.defineProperty(ResultsMapComponent.prototype, "identifier", {
        get: function () {
            if (this.activeAirport.identifier != null && this.activeAirport.identifier.toUpperCase().startsWith('ZZ')) {
                return '';
            }
            else {
                return this.activeAirport.identifier + ' :';
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ResultsMapComponent.prototype, "eventDatesMessage", {
        get: function () {
            var queryStart = moment(new Date(this.aviationEventsFilter.startDate).setHours(0, 0, 0, 0));
            var queryEnd = moment(new Date(this.aviationEventsFilter.endDate).setHours(23, 59, 59, 999));
            var queryStartDateDisplay = moment(queryStart).local().format('MM-DD-YYYY');
            var queryEndDateDisplay = moment(queryEnd).local().format('MM-DD-YYYY');
            return 'Displaying Events From ' + queryStartDateDisplay + ' TO ' + queryEndDateDisplay;
        },
        enumerable: true,
        configurable: true
    });
    ResultsMapComponent.prototype.ngAfterViewInit = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.map.mapReady.subscribe(function (map) {
                            _this._nativeMap = map;
                        });
                        return [4 /*yield*/, this._google.promise];
                    case 1:
                        _a.sent();
                        // Initialize map bounds
                        this.updateBounds();
                        this._analyticsService.pageView('airport_search_results', 'Airport/Event Search Results');
                        if (this._auth.authenticated && this._auth.endUser) {
                            this._analyticsService.trackEvent('airport_search_results_loggedin', this._auth.recid, this._auth.recid);
                        }
                        else {
                            this._analyticsService.trackEvent('airport_search_results_loggedout', '', '');
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    ResultsMapComponent.prototype.ngOnChanges = function (changes) {
        this.aviationEvents = this.aviationEvents.filter(function (ae) {
            if ((ae.format === 'In-Person' || ae.format === 'Both') &&
                (ae.location && ae.location.lat && ae.location.lon)) {
                return true;
            }
            else {
                return false;
            }
        });
    };
    ResultsMapComponent.prototype.updateSize = function () {
        this.map.triggerResize(true);
    };
    ResultsMapComponent.prototype.setCenter = function (center) {
        var latlon = { lat: center.lat, lng: center.lon };
        this._nativeMap.setCenter(latlon);
    };
    ResultsMapComponent.prototype.updateBounds = function () {
        var _this = this;
        setTimeout(function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var bounds, offset, center, offset;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this._google.promise];
                    case 1:
                        _a.sent();
                        if ((this.airports || []).length > 0 || (this.activities || []).length) { //  || (this.aviationEvents || []).length
                            // Fit airport markers
                            bounds = new google.maps.LatLngBounds();
                            (this.airports || []).forEach(function (airport) {
                                bounds.extend(new google.maps.LatLng(airport.location.lat, airport.location.lon));
                            });
                            // Fit activity markers
                            (this.activities || []).forEach(function (activity) {
                                bounds.extend(activity.geometry.location);
                            });
                            offset = 0.008;
                            center = bounds.getCenter();
                            bounds.extend(new google.maps.LatLng(center.lat() + offset, center.lng() + offset));
                            bounds.extend(new google.maps.LatLng(center.lat() - offset, center.lng() - offset));
                        }
                        else if (this.initialBounds) {
                            bounds = {
                                north: this.initialBounds.ne.lat,
                                east: this.initialBounds.ne.lon,
                                south: this.initialBounds.sw.lat,
                                west: this.initialBounds.sw.lon
                            };
                        }
                        else if (this.initialLocation) {
                            bounds = new google.maps.LatLngBounds();
                            offset = 2.5;
                            bounds.extend(new google.maps.LatLng(this.initialLocation.lat + offset, this.initialLocation.lon + offset));
                            bounds.extend(new google.maps.LatLng(this.initialLocation.lat - offset, this.initialLocation.lon - offset));
                            this.setCenter(this.initialLocation);
                        }
                        else {
                            // Center on CONUS
                            bounds = new google.maps.LatLngBounds(new google.maps.LatLng(24.396308, -124.848974), new google.maps.LatLng(49.384358, -66.885444));
                        }
                        this._nativeMap.fitBounds(bounds);
                        return [2 /*return*/];
                }
            });
        }); }, 0);
    };
    ResultsMapComponent.prototype.getIconUrl = function (activity) {
        return GoogleService.getIconUrl(activity);
    };
    ResultsMapComponent.prototype.getAirportIconUrl = function (airport) {
        if (!airport.minPrice || !airport.minPriceType) {
            return 'assets/icons/airport-map-pin.png';
        }
        if (airport.minPriceType === 'High') {
            return 'assets/icons/square-pin-red.png';
        }
        else if (airport.minPriceType === 'Medium') {
            return 'assets/icons/square-pin-yellow.png';
        }
        else {
            return 'assets/icons/square-pin-green.png';
        }
    };
    ResultsMapComponent.prototype.getAviationEventIconUrl = function (aviationEvent) {
        if (aviationEvent.type === AviationEventType.RustyPilotsSeminar) {
            return 'assets/icons/Rusty-Pilots-Event-Map-Marker.png';
        }
        else {
            return 'assets/icons/Event-Map-Marker.png';
        }
    };
    ResultsMapComponent.prototype.getEventIconZIndex = function (aviationEvent) {
        if (aviationEvent.type === AviationEventType.RustyPilotsSeminar) {
            return 600;
        }
        else {
            return 500;
        }
    };
    ResultsMapComponent.prototype.onAirportMarkerHover = function (airport, hover) {
        this.toggleAirportInfoTooltip(airport, hover);
        if (hover) {
            this.airportMouseEnter.emit(airport);
        }
        else {
            this.airportMouseLeave.emit(airport);
        }
    };
    ResultsMapComponent.prototype.onAirportMarkerClick = function (airport) {
        this.airportClick.emit(airport);
    };
    ResultsMapComponent.prototype.onActivityMarkerHover = function (activity, hover) {
        var _this = this;
        clearTimeout(this.hoverTimer);
        this.hoverTimer = setTimeout(function () {
            if (hover) {
                _this.activityMouseEnter.emit(activity);
            }
            else {
                _this.activityMouseLeave.emit(activity);
            }
        }, 400);
    };
    ResultsMapComponent.prototype.onActivityMarkerClick = function (activity) {
        this.activityClick.emit(activity);
    };
    ResultsMapComponent.prototype.onAviationEventMarkerHover = function (aviationEvent, hover) {
        var _this = this;
        this.toggleAviationEventInfoTooltip(aviationEvent, hover);
        clearTimeout(this.hoverTimer);
        this.hoverTimer = setTimeout(function () {
            if (hover) {
                _this.aviationEventMouseEnter.emit(aviationEvent);
            }
            else {
                _this.aviationEventMouseLeave.emit(aviationEvent);
            }
        }, 400);
    };
    ResultsMapComponent.prototype.onAviationEventMarkerClick = function (aviationEvent) {
        this.aviationEventClick.emit(aviationEvent);
    };
    ResultsMapComponent.prototype.toggleAirportInfoTooltip = function (airport, open) {
        // Don't show tooltip window if the full size card is opened
        open = open && (this.selectedAirport !== airport);
        this.toggleAirportInfoWindow(airport, this.airportInfoTooltip, open);
    };
    ResultsMapComponent.prototype.toggleAirportInfoWindow = function (airport, window, open) {
        var i = this.airports.indexOf(airport);
        if (i < 0) {
            return;
        }
        var marker = this.airportMarkers.toArray()[i];
        if (open) {
            this.infoWindowOpen(window, marker);
        }
        else {
            this.infoWindowClose(window);
        }
    };
    ResultsMapComponent.prototype.toggleAviationEventInfoTooltip = function (aviationEvent, open) {
        // Don't show tooltip window if the full size card is opened
        open = open && (this.selectedAviationEvent !== aviationEvent);
        this.toggleAviationEventInfoWindow(aviationEvent, this.aviationEventInfoTooltip, open);
    };
    ResultsMapComponent.prototype.toggleAviationEventInfoWindow = function (aviationEvent, window, open) {
        var i = this.aviationEvents.indexOf(aviationEvent);
        if (i < 0) {
            return;
        }
        var marker = this.aviationEventMarkers.toArray()[i];
        if (open) {
            this.infoWindowOpen(window, marker);
        }
        else {
            this.infoWindowClose(window);
        }
    };
    ResultsMapComponent.prototype.infoWindowOpen = function (infoWindow, marker) {
        if (marker === void 0) { marker = null; }
        infoWindow.hostMarker = marker;
        // Run outside angular to avoid triggering an endless cycle of change detection:
        // https://github.com/SebastianM/angular-google-maps/issues/796
        this._zone.runOutsideAngular(function () {
            infoWindow.open();
        });
    };
    ResultsMapComponent.prototype.infoWindowClose = function (infoWindow) {
        this._zone.runOutsideAngular(function () {
            infoWindow.close();
        });
    };
    ResultsMapComponent.prototype.onBoundsChange = function (bounds) {
        var ne = LatLon.fromAgm(bounds.getNorthEast());
        var sw = LatLon.fromAgm(bounds.getSouthWest());
        var box = new BoundingBox(ne, sw);
        this.boundsChange.emit(box);
    };
    ResultsMapComponent.prototype.onCloseAirportCardWindow = function () {
        this.airportCardClose.emit();
    };
    ResultsMapComponent.prototype.onCloseActivityWindow = function (activity) {
        this.activityCardClose.emit(activity);
    };
    ResultsMapComponent.prototype.onCloseAviationEventCardWindow = function () {
        this.aviationEventCardClose.emit();
    };
    return ResultsMapComponent;
}());
export { ResultsMapComponent };
